import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../Projects/ProjectCards";
import ShinyText from './ShinyText';

import credit_rating from "../../assets/Projects/credit_rating.png";
import facemask from "../../assets/Projects/facemask.png";
import volsur from "../../assets/Projects/volsur.png";

function Home_feaproj() {
    return (
        <Container fluid className="project-section">
        <Container>
          <h1 className="project-heading" style={{ textAlign: "left" }}>
            Featured <strong className="purple">Projects </strong>
          </h1>

          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={credit_rating}
                isBlog={false}
                title={
                        <>
                          Corporate Credit Rating on
                          <br />
                          Automotive Industries
                        </>
                      }
                description="Designed a credit risk scorecard for global automobile manufacturers by selecting key financial and industry-specific indicators, and benchmarking firms through peer and rating validation analysis."
                link="pre2.pdf"
                date="11-2025"
                type="Risk"
              />
            </Col>
  
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={facemask}
                isBlog={false}
                title="Face Mask Inpainting"
                description="The model is designed to remove the face-mask from facial image and inpaint the left-behind region based on a customized GAN-network approach."
                link="https://github.com/davidmilsky/Face-Mask_Inpainting"
                date="09-2021"
                type="Machine Learning"
              />
            </Col>

            <Col md={4} className="project-card">
            <ProjectCard
              imgPath={volsur}
              isBlog={false}
              title="Volatility Surfaces & Interpolation"
              description="This mini project is aimed to plot the volatility surface by computing implied volatilities via Brent's method and applying cubic spline interpolation for smooth modeling."
              link="https://colab.research.google.com/drive/106MHMgC_ykDT4BQLykJ8tmU5Y7D-V4Q9"
              date="08-2025"
              type="Quant"
            />
          </Col>

          <p2 className="project-subheading">
            <Link to="/project" style={{ textDecoration: "none", color: "inherit" }}>
              <ShinyText text="More..." disabled={false} speed={2} className='custom-class' style={{ textDecoration: "underline" }} />
            </Link>
          </p2>
          </Row>
        </Container>
      </Container>
    );
}

export default Home_feaproj;